/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Button as _Button } from '@carbon/react';
import styled from 'styled-components';

export const Buttons = styled.div`
  display: flex;
  gap: 8px;
`;

export const Button = styled(_Button)`
  align-items: center;

  svg {
    position: absolute;
    flex-shrink: 0;
    block-size: 1rem;
    inline-size: 1rem;
    inset-block-start: min((var(--cds-layout-size-height-local) - 1rem) / 2 - 0.0625rem, var(--temp-padding-block-max));
    inset-inline-end: var(--cds-layout-density-padding-inline-local);
    margin-block-start: 0;

    path,
    rect,
    circle,
    polygon,
    ellipse,
    line,
    polyline,
    g {
      fill: white;
    }
  }
`;
